"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTypeScoping = exports.addType = exports.getAll = exports.get = exports.hooks = exports.diagnostics = void 0;
const feature_1 = require("./feature");
const diagnostics_1 = require("./diagnostics");
const STSymbol = __importStar(require("./st-symbol"));
const CSSClass = __importStar(require("./css-class"));
const selector_1 = require("../helpers/selector");
const resolve_1 = require("../helpers/resolve");
const deprecation_1 = require("../helpers/deprecation");
exports.diagnostics = {
    INVALID_FUNCTIONAL_SELECTOR: diagnostics_1.generalDiagnostics.INVALID_FUNCTIONAL_SELECTOR,
    UNSCOPED_TYPE_SELECTOR(name) {
        return `unscoped type selector "${name}" will affect all elements of the same type in the document`;
    },
};
// HOOKS
exports.hooks = (0, feature_1.createFeature)({
    analyzeSelectorNode({ context, node, rule, walkContext: [_index, _nodes, parents] }) {
        /**
         * intent to deprecate: currently `value(param)` can be used
         * as a custom state value. Unless there is a reasonable
         * use case, this should be removed.
         */
        if (node.nodes &&
            (parents.length < 2 ||
                parents[parents.length - 2].type !== `pseudo_class` ||
                node.value !== `value`)) {
            // error on functional type
            context.diagnostics.error(rule, exports.diagnostics.INVALID_FUNCTIONAL_SELECTOR(node.value, `type`), { word: (0, selector_1.stringifySelector)(node) });
        }
        addType(context, node.value, rule);
    },
    transformSelectorNode({ context, node, selectorContext }) {
        const resolvedSymbols = context.getResolvedSymbols(context.meta);
        const resolved = resolvedSymbols.element[node.value] || [
            // provides resolution for native elements
            // that are not collected by parts
            // or elements that are added by js mixin
            {
                _kind: 'css',
                meta: context.meta,
                symbol: { _kind: 'element', name: node.value },
            },
        ];
        selectorContext.setCurrentAnchor({ name: node.value, type: 'element', resolved });
        // native node does not resolve e.g. div
        if (resolved && resolved.length > 1) {
            const { symbol, meta } = (0, resolve_1.getOriginDefinition)(resolved);
            if (symbol._kind === 'class') {
                CSSClass.namespaceClass(meta, symbol, node, selectorContext.originMeta);
            }
            else {
                node.value = symbol.name;
            }
        }
    },
});
// API
function get(meta, name) {
    return STSymbol.get(meta, name, `element`);
}
exports.get = get;
function getAll(meta) {
    return STSymbol.getAllByType(meta, `element`);
}
exports.getAll = getAll;
function addType(context, name, rule) {
    const typeSymbol = STSymbol.get(context.meta, name, `element`);
    if (!typeSymbol && (0, selector_1.isCompRoot)(name)) {
        let alias = STSymbol.get(context.meta, name);
        if (alias && alias._kind !== 'import') {
            alias = undefined;
        }
        STSymbol.addSymbol({
            context,
            symbol: {
                _kind: 'element',
                name,
                alias,
            },
            node: rule,
            safeRedeclare: !!alias,
        });
        // deprecated
        (0, deprecation_1.ignoreDeprecationWarn)(() => {
            context.meta.elements[name] = STSymbol.get(context.meta, name, `element`);
        });
    }
    return STSymbol.get(context.meta, name, `element`);
}
exports.addType = addType;
function validateTypeScoping({ context, locallyScoped, reportUnscoped, node, nodes, index, rule, }) {
    if (locallyScoped === false) {
        if (CSSClass.checkForScopedNodeAfter(context, rule, nodes, index) === false) {
            if (reportUnscoped) {
                context.diagnostics.warn(rule, exports.diagnostics.UNSCOPED_TYPE_SELECTOR(node.value), {
                    word: node.value,
                });
            }
            return false;
        }
        else {
            locallyScoped = true;
        }
    }
    return locallyScoped;
}
exports.validateTypeScoping = validateTypeScoping;
//# sourceMappingURL=css-type.js.map